var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhoneNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.333,25H2.667A2.59,2.59,0,0,1,0,22.5V2.5A2.59,2.59,0,0,1,2.667,0L13.333.013A2.585,2.585,0,0,1,16,2.5v20A2.59,2.59,0,0,1,13.333,25ZM3,20v2H13V20ZM3,4V17H13V4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoneNumber);
export default __webpack_public_path__ + "static/media/icon-phone-number.cccf2445d7094f4a9a6e64e740ac4ba7.svg";
export { ForwardRef as ReactComponent };